
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import FollowUpModal from './components/FollowUpModal.vue';
import lazyInject from '@/di';
import CustomerFundingService from '@/services/customerFunding.service';
import SpuService from '@/services/spu.service';
import moment from 'moment';
import FollowsListModal from './components/FollowsListModal.vue';
import screenShopModal from './components/screenShopModal.vue';
import UTILService from '@/services/utils.service';
import { AuthEnum } from '@/services/permission.service';
import VisitDetailListModal from './components/VisitDetailListModal.vue';

@Component({
  components: {
    FollowUpModal,
    FollowsListModal,
    screenShopModal,
    VisitDetailListModal,

  },
})
export default class CustomerFundingKA extends Vue {
  @lazyInject(CustomerFundingService)
  private customerFundingService!: CustomerFundingService;

  @Ref('followUpModal')
  followUpModal!: FollowUpModal;

  AuthEnum = AuthEnum;

  @Ref('followsListModal')
  followsListModal!: FollowsListModal;

  @Ref('screenShopModal')
  screenShopModal!: screenShopModal;

  @Ref('visitDetailListModal')
  visitDetailListModal!: VisitDetailListModal;

  @lazyInject(SpuService)
  private spuService!: SpuService;
  @lazyInject(UTILService)
  utilService!: UTILService;

  form: any = {
    ka_id: '',
    lead_id: '',
    status: undefined,
    ctime_start: '',
    ctime_end: '',
    phone: '',
    shop_name: '',
    poi: '',
    category: undefined,
    shop_id: '',
    compensation: '',
  };
  columns: any[] = [
    // {
    //   title: '广告主ID',
    //   dataIndex: 'ad_id',
    //   key: 'ad_id',
    //   align: 'center',
    // },
    // {
    //   title: '广告主电话',
    //   dataIndex: 'ad_phone',
    //   key: 'ad_phone',
    //   align: 'center',
    // },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
    },
    {
      title: '客资电话',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
      width: 180,
      scopedSlots: { customRender: 'phone' },
    },
    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
    },
    {
      title: '客资类型',
      dataIndex: 'category',
      key: 'category',
      align: 'center',
      width: 100,
    },
    {
      title: '获取时间',
      dataIndex: 'ctime',
      key: 'ctime',
      align: 'center',
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
    },
    // {
    //   title: '客户来源',
    //   dataIndex: 'customerSource',
    //   key: 'customerSource',
    //   align: 'center',
    // },
    {
      title: '客资状态',
      dataIndex: 'status_str',
      key: 'status_str',
      align: 'center',
    },
    {
      title: '赔付状态',
      dataIndex: 'compensation',
      key: 'compensation',
      align: 'center',
      width: 100,
      customRender: (text: any) => {
        if (text === 0) {
          return '未赔付';
        } else if (text === 1) {
          return '赔付成功';
        } else if (text === 2) {
          return '赔付失败';
        } else if (text === 9) {
          return '--';
        } else {
          return '';
        }
      },
    },
    {
      title: 'leadId',
      dataIndex: 'lead_id',
      key: 'lead_id',
      align: 'center',
      width: 180,
    },
    {
      title: '跟进备注',
      dataIndex: 'last_follow_info',
      key: 'last_follow_info',
      align: 'center',
      width: 200,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 180,
    },
  ];
  data: any[] = [];
  kaList: any[] = [];

  activeKey: any = '1';
  all = '全部';
  followUp = '待跟进';

  customerList: any[] = [];
  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    onChange: this.paginationChange,

  };

  statusList: any[] = [
    {
      value: 0,
      label: '待联系',
    },
    {
      value: 1,
      label: '待到店',
    },
    {
      value: 2,
      label: '已到店',
    },
    {
      value: 3,
      label: '已交易',
    },
    {
      value: 4,
      label: '未接通',
    },
    {
      value: 5,
      label: '无意向',
    },
  ];


  copmensList: any[] = [
    {
      value: '',
      label: '全部',
    },
    {
      value: '0',
      label: '未赔付',
    },
    {
      value: '1',
      label: '赔付成功',
    },
    {
      value: '2',
      label: '赔付失败',
    },
  ];

  ctime_arr: any[] = [];
  encryptAccount: any = '';

  @Watch('$route.query')
  queryChange() {
    const { ka_id, lead_id, status, ctime_start, ctime_end, phone, shop_name, poi, category, page, pageSize, activeKey, shop_id, compensation } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (ka_id) {
      query.ka_id = ka_id;
      this.form.ka_id = +ka_id;
    } else
      if (this.kaList.length) {
        query.ka_id = this.kaList[0].val;
        this.form.ka_id = this.kaList[0].val;
      }

    if (lead_id) {
      query.lead_id = lead_id;
      this.form.lead_id = lead_id;
    }
    if (status !== undefined) {
      query.status = status;
      this.form.status = +status;
    }
    if (ctime_start && ctime_end) {
      query.ctime_start = ctime_start;
      query.ctime_end = ctime_end;
      this.ctime_arr = [moment(ctime_start as string), moment(ctime_end as string)];
    }
    if (phone) {
      query.phone = phone;
      this.form.phone = phone;
    }
    if (shop_name) {
      query.shop_name = shop_name;
      this.form.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
      this.form.poi = poi;
    }
    if (category) {
      query.category = category;
      this.form.category = category;
    }
    if (shop_id) {
      query.shop_ids = shop_id;
      this.form.shop_id = shop_id;
    }
    if (activeKey) {
      this.activeKey = activeKey;
      if (activeKey === '2') {
        query.status = 0;
      }
    }
    if (compensation !== undefined) {
      query.compensation = compensation;
      this.form.compensation = compensation;
    }
    this.getCustomerFundingList(query);
  }
  callback(key: string) {
    this.activeKey = key;
    this.search();
  }
  search() {
    this.pagination.current = 1;
    this.getQuery();
  }
  selectShop(shopList: any[]) {
    this.form.shop_id = shopList.join(',');
    // console.log(this.form.shop_id);
    this.getQuery();
  }

  async LookShopDetail(title: string, encryptAccount: string) {
    const data = {
      encrypt_phone: encryptAccount,
      operate_type: title,
    };
    try {
      const res = await this.utilService.postPhoneDecrypt(data);
      if (res) {
        this.encryptAccount = res;
        this.$info({
          title: '客资列表-客资电话',
          centered: true,
          content: res,
        });
      }
    } catch (error) {
      this.$message.error('解密失败');
    }
  }
  refresh() {
    this.getQuery();
  }
  reset() {
    this.form = {
      ka_id: '',
      lead_id: '',
      status: '',
      ctime_start: '',
      ctime_end: '',
      phone: '',
      shop_name: '',
      poi: '',
      category: undefined,
      shop_id: '',
      compensation: '',
    };
    this.ctime_arr = [];
    this.pagination.current = 1;
    this.getQuery();
  }
  handleEdit(record: any) {
    this.followUpModal.init(record);
  }
  handleFollowsList(record: any) {
    this.followsListModal.init(record);
  }
  paginationChange(current: number, pageSize: number) {
    this.pagination.current = current;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }

  shopRoutes() {
    this.screenShopModal.init(this.form);
  }
  getQuery() {
    const { ka_id, lead_id, status, ctime_start, ctime_end, phone, shop_name, poi, category, shop_id, compensation } = this.form;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
    };
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (lead_id) {
      query.lead_id = lead_id;
    }
    if (status) {
      query.status = status;
    }
    if (ctime_start && ctime_end) {
      query.ctime_start = ctime_start;
      query.ctime_end = ctime_end;
    }
    if (phone) {
      query.phone = phone;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (poi) {
      query.poi = poi;
    }
    if (category) {
      query.category = category;
    }
    if (shop_id) {
      query.shop_id = shop_id;
    }
    if (compensation !== undefined) {
      query.compensation = compensation;
    }
    query.activeKey = this.activeKey;
    query.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query,
    });
  }

  onChangeCreateTime(date: any) {
    // console.log('CustomerFunding onChangeCreateTime', date);
    if (date && date.length) {
      this.form.ctime_start = moment(date[0]).format('YYYY-MM-DD');
      this.form.ctime_end = moment(date[1]).format('YYYY-MM-DD');
    } else {
      this.form.ctime_start = '';
      this.form.ctime_end = '';
    }
  }

  async getCustomerFundingList(params: any) {
    const response = await this.customerFundingService.getCustomerFundingList(params);
    if (response) {
      this.data = response.list;
      this.pagination.total = response.total;
    }
  }
  async getKaList() {
    const res = await this.spuService.kaSpuAccessibleKas();
    if (res && res.length) {
      this.kaList = [...res];
      this.queryChange();
    }
  }
  async getCategoryList() {
    const response = await this.customerFundingService.getCategoryList();
    const list: any = [];
    for (const item in response) {
      if (item) {
        list.push({
          value: item,
          label: response[item],
        });
      }
    }
    this.customerList = list;
  }
  mounted() {
    this.getCategoryList();
    this.getKaList();
  }

  handleVisitDetailList(record: any) {
    this.visitDetailListModal.init(record);
  }
}
